import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/presentation/assets/img/logo-square.svg'


const _hoisted_1 = {
  class: "navbar navbar-vertical fixed-start navbar-expand-md pt-md-7",
  id: "sidebar"
}
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "navbar-user d-md-none" }
const _hoisted_4 = { class: "dropdown" }
const _hoisted_5 = { class: "dropdown-menu dropdown-menu-end" }
const _hoisted_6 = {
  class: "collapse navbar-collapse",
  id: "sidebarCollapse"
}

import { useMainStore } from "@/infra/store";
import { SidebarMenu } from "@/utils";
import { computed, ref } from "vue";
import { routes } from "../router";
import SidebarHeaderItem from "./SidebarHeaderITem.vue";



export default /*@__PURE__*/_defineComponent({
  __name: 'Sidebar',
  setup(__props) {

const screens = ref(SidebarMenu);
const session = computed(() => useMainStore().session);

return (_ctx: any,_cache: any) => {
  const _component_Logo = _resolveComponent("Logo")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("button", {
        class: "navbar-toggler",
        type: "button",
        "data-bs-toggle": "collapse",
        "data-bs-target": "#sidebarCollapse",
        "aria-controls": "sidebarCollapse",
        "aria-expanded": "false",
        "aria-label": "Toggle navigation"
      }, [
        _createElementVNode("span", { class: "navbar-toggler-icon" })
      ], -1)),
      _createVNode(_component_Logo, {
        height: "30",
        class: "d-md-none"
      }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[3] || (_cache[3] = _createElementVNode("a", {
            href: "#",
            id: "sidebarIcon",
            class: "dropdown-toggle",
            role: "button",
            "data-bs-toggle": "dropdown",
            "aria-haspopup": "true",
            "aria-expanded": "false"
          }, [
            _createElementVNode("div", { class: "avatar avatar-sm" }, [
              _createElementVNode("img", {
                src: _imports_0,
                class: "avatar-img rounded-circle",
                alt: "..."
              })
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_router_link, {
              to: {
                name: _unref(routes).admins.detail?.name,
                params: { id: session.value?.id },
              },
              class: "dropdown-item"
            }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createTextVNode("Minha conta")
              ])),
              _: 1
            }, 8, ["to"]),
            _cache[2] || (_cache[2] = _createElementVNode("hr", { class: "dropdown-divider" }, null, -1)),
            _createVNode(_component_router_link, {
              to: _unref(routes).login.path,
              class: "dropdown-item text-danger"
            }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createTextVNode("Sair")
              ])),
              _: 1
            }, 8, ["to"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(screens.value, (screen, index) => {
          return (_openBlock(), _createBlock(SidebarHeaderItem, {
            header: screen,
            key: index
          }, null, 8, ["header"]))
        }), 128))
      ])
    ])
  ]))
}
}

})